import { Capacitor } from '@capacitor/core';
import { reactive } from 'vue';
import AndroidFirebaseMessagingService from './android-messaging.service';
import BrowserFirebaseMessagingService from './browser-messaging.service';
import NotificationService from '../notification.service';
const state = reactive({
    deferredPrompt: null,
    showInstallMessage: false,
    selectedLanguage: 'en',
    languages: {
        en: 'English',
        it: 'Italiano',
        sp: 'Español',
    },
    notificationState: {
        isEnabled: false,
        token: '',
        error: null
    }
});
// Factory per creare il servizio appropriato
class FirebaseMessagingService {
    service;
    constructor() {
        if (Capacitor.isNativePlatform()) {
            console.log('🔥 Creazione servizio Android');
            this.service = new AndroidFirebaseMessagingService(state);
        }
        else {
            console.log('🔥 Creazione servizio Browser');
            this.service = new BrowserFirebaseMessagingService(state);
        }
    }
    async initialize() {
        return this.service.initialize();
    }
    async getToken() {
        try {
            const token = await this.service.getToken();
            if (token) {
                await this.sendTokenToServer(token);
                state.notificationState.token = token;
                state.notificationState.isEnabled = true;
            }
            else {
                console.warn('⚠️ Token non disponibile');
                state.notificationState.isEnabled = false;
                state.notificationState.error = 'Token not available';
            }
        }
        catch (error) {
            console.error("Error getting Firebase token:", error);
            state.notificationState.error = error instanceof Error ? error.message : String(error);
            state.notificationState.isEnabled = false;
        }
        return Promise.resolve(state.notificationState.token);
    }
    async cleanup() {
        return this.service.cleanup();
    }
    async subscribeToTopic(topic) {
        return this.service.subscribeToTopic(topic);
    }
    async unsubscribeFromTopic(topic) {
        return this.service.unsubscribeFromTopic(topic);
    }
    // Metodo pubblico per inizializzare le notifiche (utilizzato nel componente)
    async initializeNotifications() {
        try {
            console.log('🚀 Inizializzazione notifiche...');
            await this.initialize();
        }
        catch (error) {
            console.error('💥 Errore inizializzazione notifiche:', error);
            state.notificationState.error = error instanceof Error ? error.message : String(error);
            state.notificationState.isEnabled = false;
        }
    }
    async sendTokenToServer(token) {
        try {
            const service = new NotificationService();
            const response = await service.savePushToken(token);
            if (response.ok) {
                console.log('✅ Token Android inviato al server');
            }
        }
        catch (error) {
            console.error('❌ Errore invio token Android al server:', JSON.stringify(error));
        }
    }
    getState() {
        return this.service.getState();
    }
}
export default FirebaseMessagingService;
